import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';

import * as Sentry from '@sentry/angular';

Sentry.init({
  dsn: process.env.NX_COWORKRZ_ADMIN_SENTRY_DSN,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
  ],
  tracePropagationTargets: [process.env.NX_API_ENDPOINT as string],
  environment: process.env.NX_ENV,
  tracesSampleRate: process.env.NX_ENV === 'prod' ? 0.5 : 1.0,
  replaysSessionSampleRate: process.env.NX_ENV === 'prod' ? 0.5 : 1.0,
  replaysOnErrorSampleRate: 1.0,
});

bootstrapApplication(AppComponent, appConfig).catch((err) =>
  console.error(err)
);
